import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { 
  loadKiosks,
  removeKiosk,
} from '../../reducers/kiosks';

class Kiosks extends Component {

  componentWillReceiveProps = () => {
  }

  removeKiosk = (kiosk) => {
    if(window.confirm(`Do you want to remove ${kiosk.kiosk_name}?`)){
      this.props.removeKiosk(kiosk.kiosk_id);
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Kiosks</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="input-group col-md-4">
                {/* <input type="text" className="form-control" aria-label="Text input with dropdown button" placeholder="Search Kiosk" /> */}
              </div>

              <div className="col-md-4 offset-md-4">
                <Link to="/kiosks/add" className="btn btn-primary float-right">Add Kiosk</Link>
              </div>

            </div>
            
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Kiosk</th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingKiosks &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>Loading Kiosks</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingKiosks && this.props.kiosks.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>0 Kiosks</em></td>
                  </tr>
                </tbody>
              }
              {this.props.kiosks &&
                <tbody>
                  {this.props.kiosks.map((kiosk, idx) => {
                    return (
                      <tr key={`kiosk-${idx}`}>
                        <td>
                          <strong>{kiosk.kiosk_name}</strong><br/>
                          {kiosk.kiosk_description}
                        </td>
                        <td>
                          <Link to={`/kiosks/${kiosk.kiosk_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                          <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeKiosk(kiosk)}>Remove</button>&nbsp;
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  kiosks: state.kiosks.kiosks,
  isLoadingKiosks: state.kiosks.isLoadingKiosks
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadKiosks,
      removeKiosk,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Kiosks);


// WEBPACK FOOTER //
// ./src/modules/Kiosks/Kiosks.js